export default __webpack_public_path__ + "static/farming-it-4efbfef5bc6cd6989c724361407989b2.jpg";